import React, { useMemo } from 'react';
import { MemoryRouter, Route, Redirect, Switch } from 'react-router';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import { connect } from 'react-redux';

import Review from 'Containers/Review';
import { myProfile } from 'Redux/user-profile/selectors';
import { useClassroomInterruption } from 'Util/Hooks';
import { useGetFeedback } from 'Util/FeedBackService';

import { QuizProvider } from '../../Context/QuizContext';

import { QUIZ_SUB_ROUTES } from './constant';
import QuizErrorModal from './Components/QuizErrorModal';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const DialogLayout = (props) => {
  return (
    <Dialog
      open={true}
      fullScreen={true}
      TransitionComponent={Transition}
      disableBackdropClick
      disableEscapeKeyDown
      {...props}
    />
  );
};

const Quiz = ({
  quiz,
  onEndQuiz,
  onCompleted,
  variant,
  userId,
  isLastSubsectionInCourse,
  onExitClassroom,
}) => {
  const {
    examId,
    description,
    title,
    maxAttempts,
    timeLimit,
    courseAssetId,
    fullScore,
    passingScore,
    resultOptions,
    type,
  } = quiz;
  const {
    isInterrupting,
    activateInterruption,
    deactivateInterruption,
    courseData: { courseCode, courseTitle, progressPercent },
  } = useClassroomInterruption();

  const { data: reviewData } = useGetFeedback({
    templateId: 'SKOOLDIO_FEEDBACK',
    contentId: courseCode,
    userId,
  });

  const nextReviewRevision = useMemo(() => {
    const reviews = reviewData?.getFeedback ?? [];
    return reviews.length + 1;
  }, [reviewData]);

  return (
    <QuizProvider
      metadata={{
        title,
        type,
        description,
        maxAttempts,
        timeLimit,
        fullScore,
        passingScore,
        resultOptions,
      }}
      examId={examId}
      courseAssetId={courseAssetId}
      variant={variant}
      openCourseReviewModal={activateInterruption}
      isLastSubsectionInCourse={isLastSubsectionInCourse}
      onExitClassroom={onExitClassroom}
    >
      {isInterrupting && (
        <Review
          isShow={isInterrupting}
          onCloseReview={deactivateInterruption}
          courseTitle={courseTitle}
          progressPercent={progressPercent}
          revision={nextReviewRevision}
        />
      )}

      <QuizErrorModal />
      <MemoryRouter>
        <Switch>
          <Route
            exact={true}
            path={'/'}
            render={() => <Redirect to={QUIZ_SUB_ROUTES.LANDING.getPath(examId)} />}
          />
          <Route
            exact={QUIZ_SUB_ROUTES.LANDING.exact}
            path={QUIZ_SUB_ROUTES.LANDING.path}
            render={(props) => {
              const Component = QUIZ_SUB_ROUTES.LANDING.component;
              return <Component onEndQuiz={onEndQuiz} {...props} {...quiz} />;
            }}
          />
          <Route
            exact={QUIZ_SUB_ROUTES.GRADED_EXAM_RESULT.exact}
            path={QUIZ_SUB_ROUTES.GRADED_EXAM_RESULT.path}
            render={(props) => {
              const Component = QUIZ_SUB_ROUTES.GRADED_EXAM_RESULT.component;
              return <Component onEndQuiz={onEndQuiz} {...props} {...quiz} />;
            }}
          />
          <DialogLayout>
            <Switch>
              {Object.keys(QUIZ_SUB_ROUTES).map((key) => {
                const route = QUIZ_SUB_ROUTES[key];
                const { exact, path, component: Component } = route;
                if (key !== 'LANDING' || key !== 'GRADED_EXAM_RESULT') {
                  return (
                    <Route
                      key={path}
                      exact={exact}
                      path={path}
                      render={(props) => (
                        <Component
                          onExitClassroom={onExitClassroom}
                          onEndQuiz={onEndQuiz}
                          onCompleted={onCompleted}
                          {...props}
                        />
                      )}
                    />
                  );
                }
              })}
            </Switch>
          </DialogLayout>
        </Switch>
      </MemoryRouter>
    </QuizProvider>
  );
};

export default connect((state) => {
  const user = myProfile(state);
  return {
    userId: user.id,
  };
}, {})(Quiz);
